import axios from 'axios';
import store from '@/store';
import { captureError } from '@/Utils/Sentry/captureErrorSentry';

let sessionID = localStorage.getItem('sessionID');

const lms = axios.create({
  baseURL: `${process.env.VUE_APP_CORE_BASE_URL}/learning`,
  headers: {
    'Content-Type': 'application/json',
    'X-gprim-specnav': window.navigator.userAgent,
    'X-gprim-specdev': 'WEB',
    sessionid: sessionID,
    'X-gprim-specver': '2.2.1',
  },
});

lms.interceptors.request.use(
  function (config) {
    const token = store.getters['auth/token'];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (sessionID) {
      config.headers['sessionid'] = sessionID;
    }
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

lms.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (err) => {
    const hasError4xx = err?.response?.status === 401 || err?.response?.status === 403;
    captureError(err, hasError4xx ? 'log' : 'error');
    if (err.response && hasError4xx) {
      await store.dispatch('currentLogout');
    }

    return Promise.reject(err);
  }
);

export default lms;
